import type { InterfaceTableMeta } from '../../app'

// Reviewed by a native speaker, the owner (ADR-111 Amendment 1, clause 3).
export const meta: InterfaceTableMeta = { review: 'native-reviewed' }
